
import React, { useEffect, useState } from "react";
import { hideDiv, showDiv } from '../../../utility/utility';
import { useDispatch, useSelector } from "react-redux";
import { updateApplication, isThunkFulfilled } from "../../../store/reducers/applicationSlice";
import iconAlertClose from "../../../assets/media/icon-alert-close.svg";

const DescripanciesBox = ({ descrepancies, setCurrentPage, currentPage, setSelectedFieldData, selectedFieldData, formId, applicationState, userId, applicationName }) => {
    const dispatch = useDispatch();
    const [currentFieldSelected, setCurrentFieldSelected] = useState("null");
    const [additionalNotes, setAdditionalNotes] = useState("");
    const user = useSelector((state) => state.auth.user);
    const authToken = user.access_token;

    useEffect(() => {
        const notes = selectedFieldData?.additional_notes;
        if (typeof notes === "string") {
            setAdditionalNotes(notes);
        } else if (notes?.value != null) {
            setAdditionalNotes(notes.value);
        } else if (notes == null) {
            setAdditionalNotes("");
        }
    }, [selectedFieldData?.additional_notes]);

    const handleAddDiscrepancy = async () => {
        const currentTime = new Date().toLocaleTimeString();
// Debug log

        const { additional_notes: _ignored, ...fieldDiscrepancies } = selectedFieldData || {};

        const payload = {
            token: authToken,
            id: formId,
            currentTime,
            descripencie: {
                ...fieldDiscrepancies,
                additional_notes: additionalNotes,
            },
        };

// Debug log

        const result = await dispatch(updateApplication(payload));
        if (!isThunkFulfilled(result)) return;
    };

    const handleInputChange = (id, value) => {
        setSelectedFieldData(prevFields => {
            // Create a new object for the updated field
            const updatedField = {
                ...prevFields[id],
                value: value
            };

            // Return a new state object
            return {
                ...prevFields,
                [id]: updatedField
            };
        });
    }

    const inputBoxClicked = (id) => {
        if (currentFieldSelected !== id) {
            if (currentFieldSelected !== "null") {
                const currentFieldSelectedElement = document.getElementById(currentFieldSelected.replace("dis_", ""));
                currentFieldSelectedElement.style.backgroundColor = '';

            }
            setCurrentFieldSelected(id);
            id = id.replace("dis_", "");
            const temp = id.split('_');
            const pageId = temp[temp.length - 1];
            if (currentPage !== pageId) {
                hideDiv(currentPage)
                showDiv(pageId)
                setCurrentPage(pageId);
            }
            const element = document.getElementById(id);
            if (element) {
                element.style.backgroundColor = '#ff0000'; // Change background color to red
            }

        } else {
            id = id.replace("dis_", "");
            const element = document.getElementById(id);
            if (element) {
                element.style.backgroundColor = ''; // Change background color to red
            }
            setCurrentFieldSelected("null");
        }

    }

    const canEditDiscrepancies =
        user?.user?.user_role === 'company_admin' &&
        applicationState === 'application_sent_to_discrepancy_by_company';

    return (
        <div className="discontainer">
            <div className='title'>Discrepancies</div>
            <div className='disform'>
                <div className='boardHeadRight'>
                    <div className='boardFilter'>
                        {Object.entries(selectedFieldData || {})
                            .filter(([id]) => id !== 'additional_notes')
                            .map(([id, data]) => (
                            <div className="form-check form-check-inline d-flex gap-1 align-items-center" key={id}>
                                {user?.user?.user_role === 'company_admin' && applicationState !== 'descrepency_GB_Company' ? (
                                    <input
                                        id={`checkbox_${id}`}
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={data.check}
                                        onChange={() => {
                                            if (user?.user?.user_role !== 'employee') {
                                                setSelectedFieldData(prev => {
                                                    const newData = { ...prev };
                                                    if (newData[id]) {
                                                        delete newData[id];
                                                        // Remove red background from form field
                                                        const formField = document.getElementById(id.replace('dis_', ''));
                                                        if (formField) {
                                                            formField.style.backgroundColor = '';
                                                        }
                                                    }
                                                    return newData;
                                                });
                                            }
                                        }}
                                        readOnly={user?.user?.user_role === 'employee' ? true : false}
                                    />
                                ) : null}
                                <textarea
                                    id={id + "_text"}
                                    placeholder="Enter discrepancy description"
                                    value={data.value || ''}
                                    onChange={(e) => handleInputChange(id, e.target.value)}
                                    ref={(el) => {
                                        if (el) {
                                            el.style.height = "auto";
                                            el.style.height = el.scrollHeight + "px";
                                        }
                                    }}
                                    className="form-check-label"
                                    style={{
                                        flex: 1,
                                        resize: "none",
                                        overflow: "hidden",
                                        minHeight: "38px",
                                        padding: "6px 12px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px"
                                    }}
                                    rows={1}
                                    readOnly={user?.user?.user_role === 'employee' || applicationState === 'descrepency_GB_Company' ? true : false}
                                />
                                <div onClick={() => { inputBoxClicked(id) }
                                }>
                                    <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z" /></svg>
                                </div>
                                {/* <label style={{ marginLeft: '8px', fontSize: '12px', color: '#666' }}>
                                    Field: {id.replace('dis_', '')}
                                </label> */}
                            </div>
                        ))}
                        {canEditDiscrepancies ? (
                            <div style={{ padding: '20px 0 0', textAlign: 'center', color: '#666', fontSize: '14px' }}>
                                Click on form fields to add discrepancies
                            </div>
                        ) : null}
                        {(canEditDiscrepancies || additionalNotes) ? (
                            <div style={{ padding: '12px 0 20px', marginBottom: '30px' }}>
                                <label
                                    htmlFor="additional_notes"
                                    style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontSize: '13px',
                                        fontWeight: 500,
                                        color: '#333',
                                    }}
                                >
                                    Additional Notes
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <textarea
                                        id="additional_notes"
                                        placeholder="Enter additional notes"
                                        value={additionalNotes}
                                        onChange={(e) => setAdditionalNotes(e.target.value)}
                                        readOnly={!canEditDiscrepancies}
                                        style={{
                                            width: '100%',
                                            minHeight: '90px',
                                            padding: canEditDiscrepancies ? '8px 36px 8px 12px' : '8px 12px',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            resize: 'vertical',
                                            fontSize: '14px',
                                            backgroundColor: canEditDiscrepancies ? '#fff' : '#f5f5f5',
                                        }}
                                        rows={4}
                                    />
                                    {canEditDiscrepancies && additionalNotes ? (
                                        <button
                                            type="button"
                                            title="Clear notes"
                                            onClick={() => setAdditionalNotes("")}
                                            style={{
                                                position: 'absolute',
                                                top: '8px',
                                                right: '8px',
                                                width: '22px',
                                                height: '22px',
                                                padding: 0,
                                                border: 'none',
                                                borderRadius: '50%',
                                                background: '#e8e8e8',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                lineHeight: 1,
                                            }}
                                        >
                                            <img
                                                src={iconAlertClose}
                                                alt="Clear"
                                                style={{ width: '10px', height: '10px' }}
                                            />
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            {canEditDiscrepancies ? (
                <div className="buttonGroup">
                    <button className="AppFormButton" onClick={handleAddDiscrepancy}>Update Discrepancies</button>
                </div>
            ) : null}

        </div>
    );
};

export default DescripanciesBox;
